﻿<div data-ng-form="spinboxForm">
    <div class="row middle-xs spinbox-block" data-ng-init="spinbox.form = spinboxForm">
        <div
            class="col-xs"
            data-ng-class="{'spinbox-input-wrap': spinbox.isVisibleArrows == true}"
            data-tooltip-placement="top"
            data-tooltip-trigger="'none'"
            data-tooltip-append-to-body="true"
            data-tooltip-class="spinbox-tooltip"
            data-tooltip-is-open="spinbox.isOpenTooltip"
            data-uib-tooltip="{{spinbox.tooltipText}}">
            <input
                class="spinbox-input input-alt"
                data-ng-class="[spinbox.inputClassSize || 'input-small', spinbox.inputClasses]"
                type="text"
                data-ng-attr-name="{{spinbox.inputName}}"
                data-ng-attr-id="{{spinbox.inputName}}"
                data-ng-model="spinbox.value"
                data-ng-blur="spinbox.valueFoldStep($event)"
                data-ng-on-keydown="spinbox.keydown($event)"
                aria-label="{{'Js.Spinbox.Quantity' | translate }}"
                validation-input-text="{{spinbox.validationText}}"
                validation-input-float
                data-spinbox-input
                ng-required="{{spinbox.forceNullable == false}}" />
        </div>
        <div class="spinbox__arrows m-l-xs" data-ng-if="spinbox.isVisibleArrows == true">
            <a
                href="javascript:void(0)"
                role="button"
                aria-label="{{'Js.Spinbox.More' | translate }}"
                class="spinbox-more icon-up-open-before link-text-decoration-none"
                data-ng-click="spinbox.more()"
                data-ng-class="{'cs-l-3 spinbox-button-disabled':spinbox.moreBtnDisabled}">
            </a>
            <a
                href="javascript:void(0)"
                role="button"
                aria-label="{{'Js.Spinbox.Less' | translate }}"
                class="spinbox-less icon-down-open-before link-text-decoration-none"
                data-ng-click="spinbox.less()"
                data-ng-class="{'cs-l-3 spinbox-button-disabled':spinbox.lessBtnDisabled}"></a>
        </div>
    </div>
</div>
